import API from "./api";
import GravityForms from "./gravity-forms";

// Added by the plugin to the email fields of a form whose form settings turn email validation off.
const DISABLED_FIELD_SELECTOR = ".js-datatools-email-validation-disabled";

/**
 *  EmailValidation class that interacts with the DataTools Kleber API
 */
class EmailValidation {

	// Validate any Gravity Form email address.
	setupGfEmailValidation() {
		API.init();
		let queryCache = [];
		let emailContainers = document.querySelectorAll(".ginput_container_email");
		if (!emailContainers) {
			return;
		}

		emailContainers.forEach((container) => {
			// Skip the email fields of any form that has turned email validation off.
			if (container.closest(DISABLED_FIELD_SELECTOR)) {
				return;
			}

			let input = container.querySelector("input");

			// Skip to the next email field if input is readonly already.
			if (input.readOnly) {
				return;
			}

			if (input.dataset.datatoolsEmailInit) {
				return;
			}
			input.dataset.datatoolsEmailInit = '1';

			let inputNumber = GravityForms.getGfInputNumber(input);
			let fieldEl = document.querySelector('#field_' + inputNumber);

			input.addEventListener('blur', (event) => {
				const emailAddress = event.target.value;

				if ( !emailAddress && fieldEl.classList.contains('gfield_contains_required') ) {
					GravityForms.showGfValidationMessage( inputNumber, 'Email address is required' );
					return;
				}

				// Check for this email address validation result in the queryCache.
				if ( typeof queryCache[emailAddress] !== 'undefined' ) {
					const result = queryCache[emailAddress];
					if (!result.isValid) {
						GravityForms.showGfValidationMessage( inputNumber, result.message );
					} else {
						GravityForms.hideGfValidationMessage( inputNumber );
					}
					return;
				}

				// Make email readonly as a visual cue that we're verifying it.
				input.readOnly = true;
				API.verifyEmail(emailAddress).then((data) => {
					input.readOnly = false;
					if (!data.DtResponse.Result.length) {
						return;
					}

					data.DtResponse.Result.map(function (item) {
						const result = {
							isValid: item.StatusCode !== '2',
							message: item.StatusDescription
						}

						// Cache API result.
						queryCache[emailAddress] = result;

						if (!result.isValid) {
							GravityForms.showGfValidationMessage( inputNumber, result.message );
						} else {
							GravityForms.hideGfValidationMessage( inputNumber );
						}
					});
				}).catch((error) => {
					input.readOnly = false;
					console.dir(error);
				});
			}); // email input blur event.

		}); // forEach email.
	}

}

const EmailValidationInstance = new EmailValidation();
export default EmailValidationInstance;
